var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 512 512" },
      attrs: {
        height: "512px",
        viewBox: "0 0 512 512",
        width: "512px",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { staticClass: "st1", attrs: { id: "layer" } }, [
        _c("rect", {
          staticClass: "st0",
          attrs: { height: "188", width: "188", x: "51", y: "51" },
        }),
        _vm._v(" "),
        _c("rect", {
          staticClass: "st0",
          attrs: { height: "188", width: "188", x: "273", y: "51" },
        }),
        _vm._v(" "),
        _c("rect", {
          staticClass: "st0",
          attrs: { height: "188", width: "188", x: "51", y: "273" },
        }),
        _vm._v(" "),
        _c("rect", {
          staticClass: "st0",
          attrs: { height: "188", width: "188", x: "273", y: "273" },
        }),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "layer_copy" } }, [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M239,247H51c-4.418,0-8-3.582-8-8V51c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C247,243.418,243.418,247,239,247z     M59,231h172V59H59V231z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            attrs: {
              d: "M461,247H273c-4.418,0-8-3.582-8-8V51c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C469,243.418,465.418,247,461,247z     M281,231h172V59H281V231z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            attrs: {
              d: "M239,469H51c-4.418,0-8-3.582-8-8V273c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C247,465.418,243.418,469,239,469z     M59,453h172V281H59V453z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            attrs: {
              d: "M461,469H273c-4.418,0-8-3.582-8-8V273c0-4.418,3.582-8,8-8h188c4.418,0,8,3.582,8,8v188C469,465.418,465.418,469,461,469    z M281,453h172V281H281V453z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }